import React from 'react';
import { Panel } from '@ftdr/blueprint-components-react';
import { Address } from '@app/models';
import REText from '@components/wrappedBDS/REText';
import { useZestyPromos } from '@helpers/useZestyPromos';

interface PromoBannerProps {
  address: Address;
}

export const PromoBanner: React.FC<PromoBannerProps> = (
  props: React.PropsWithChildren<PromoBannerProps>,
) => {
  const { validPromo, showBanner, promoData } = useZestyPromos(props.address);

  return (
    <div>
      {showBanner && promoData && (
        <Panel id="promo-banner" shadow={true}>
          <div className="flex flex-row">
            <div>
              <img
                id="promo-banner-image-icon"
                src={validPromo.smallBannerImage}
                className=" min-h-8 max-h-16 object-center object-contain"
              />
            </div>
            <div>
              <REText
                id="promo-banner-text"
                className="zesty-html"
                dangerouslySetInnerHTML={{ __html: validPromo.smallBannerText }}
              />
            </div>
          </div>
        </Panel>
      )}
    </div>
  );
};
